import TaxonomyTerm from "../../types/TaxonomyTerm";
import { TaxonomyAction, TaxonomyState } from "./TaxonomyState";

export const DISPATCH = 'WIS/taxonomy/military_service/DISPATCHED';
export const FULFILL = 'WIS/taxonomy/military_service/FULFILLED';
export const REJECT = 'WIS/taxonomy/military_service/REJECTED';

export type MilitaryServiceActionTypes = 
  'WIS/taxonomy/military_service/DISPATCHED'
  | 'WIS/taxonomy/military_service/FULFILLED'
  | 'WIS/taxonomy/military_service/REJECTED';

export const dispatch = () => ({ type: DISPATCH });
export const fulfill = (payload: TaxonomyTerm[]) => ({ type: FULFILL, payload });
export const reject = (error: string) => ({ type: REJECT, error });

const initialState: TaxonomyState = {
  terms: [],
  isFetching: false,
  isFetched: false,
  error: null,
};

export type TaxonomyMilitaryServiceAction = TaxonomyAction<MilitaryServiceActionTypes>;

export default function reducer(state = initialState, action: TaxonomyMilitaryServiceAction) {
  switch (action.type) {
    case DISPATCH:
      return {
        ...state,
        isFetching: true,
      };

    case FULFILL:
      return {
        ...state,
        terms: action.payload,
        isFetching: false,
        isFetched: true,
        error: null,
      };

    case REJECT:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };

    default:
      return state;
  }
}
